@let controls = form().controls;

<div class="form">
  <div>
    <div
      class="radio-input"
      [class.radio-input--outline]="appearance() === 'outline'"
      role="radiogroup"
      [attr.aria-labelledby]="radioGroupLabelId"
    >
      <div class="radio-input__label" [id]="radioGroupLabelId">{{ 'Form.Label.NewsletterType' | translate }}:</div>
      <div class="radio-input__options">
        <label class="radio-input__option">
          <input type="radio" [formControl]="controls.type" [name]="radioGroupName" [value]="NewsletterType.PAPER" />
          <span>{{ 'Form.NewsletterType.Paper' | translate }}</span>
        </label>
        <label class="radio-input__option">
          <input type="radio" [formControl]="controls.type" [name]="radioGroupName" [value]="NewsletterType.EMAIL" />
          <span>{{ 'Form.NewsletterType.Email' | translate }}</span>
        </label>
      </div>
    </div>

    <pai-input-field [label]="'Form.Label.GivenName' | translate" [appearance]="appearance()">
      <input type="text" [formControl]="controls.givenName" autocomplete="given-name" />
    </pai-input-field>

    <pai-input-field [label]="'Form.Label.FamilyName' | translate" [appearance]="appearance()">
      <input type="text" [formControl]="controls.familyName" autocomplete="family-name" />
    </pai-input-field>
  </div>

  <div>
    @if (controls.address.enabled) {
      <pai-input-field [label]="'Form.Label.Address' | translate" [appearance]="appearance()">
        <input type="text" [formControl]="controls.address" autocomplete="address-level3" />
      </pai-input-field>
    }

    @if (controls.postalCode.enabled) {
      <pai-input-field [label]="'Form.Label.PostalCode' | translate" [appearance]="appearance()">
        <input type="text" [formControl]="controls.postalCode" autocomplete="postal-code" />
      </pai-input-field>
    }

    @if (controls.city.enabled) {
      <pai-input-field [label]="'Form.Label.City' | translate" [appearance]="appearance()">
        <input type="text" [formControl]="controls.city" autocomplete="address-level2" />
      </pai-input-field>
    }

    @if (controls.email.enabled) {
      <pai-input-field [label]="'Form.Label.Email' | translate" [appearance]="appearance()">
        <input type="email" [formControl]="controls.email" autocomplete="email" />
      </pai-input-field>
    }

    <pai-input-field [label]="'Form.Label.Comment' | translate" [appearance]="appearance()">
      <textarea [formControl]="controls.comment" paiAutosize [rows]="4"></textarea>
    </pai-input-field>
  </div>
</div>
